import { render, staticRenderFns } from "./searchPripTaal.vue?vue&type=template&id=882f2fd8&scoped=true"
import script from "./searchPripTaal.vue?vue&type=script&lang=js"
export * from "./searchPripTaal.vue?vue&type=script&lang=js"
import style0 from "./searchPripTaal.vue?vue&type=style&index=0&id=882f2fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882f2fd8",
  null
  
)

export default component.exports